import React, {
  useState,
  useEffect
} from 'react';

import { Form, Field } from "react-final-form";

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  CircularProgress,
  Grid,
  Typography,
  Button,
  TextField,
  FormControl,
  FormHelperText,
  Select,
  InputLabel,
  MenuItem,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import {
  FileUploadField,
  UserSelectorField
} from '../../general';

import {
  BaseAPI,
} from '../../../data/BaseAPI';

import localization from '../../../utils/localizations';


const useStyles = makeStyles((theme) => ({
  mainBody: {
    padding: 10,
  },
  mainGrid: {
    marginTop: 20,
  },
  gridLabelBolder: {
    textAlign: 'right',
    fontWeight: 500,
  },
  gridLabel: {
    textAlign: 'right',
    color: '#555555',
  },
  alignRight: {
    textAlign: 'right',
  },
}));

interface Values {
  validation_forms?: string[];
  thesis_docx?: string;
  thesis_pdf?: string;
  paper_id_pdf?: string;
  paper_en_pdf?: string;
  resume_id_pdf?: string;
  resume_en_pdf?: string;
}

function ThesisPostDefenseForm(props: {onSubmitted: any, onCancelled: any, values?: Values}) {
  const classes = useStyles();

  const maxUploadSize = 100*1024*1024;
  const [isSaving, setIsSaving] = useState(false);

  const onSubmit = async (values: Values) => {
    if (isSaving) return;

    const api = new BaseAPI();
    setIsSaving(true);
    try {
      const [result, response, error] = await api.post(values, 's2/post-defense/');
      setIsSaving(false);
  
      console.log('result', result)
      if (result.success) {
        props.onSubmitted();
      }
      else {
        return result.errors;
      }
    } catch (error) {
      setIsSaving(false);
      console.log((error as any).message, (error as any).status, (error as any).errorData);
      return (error as any).errorData;
    }

  };

  const onValidate = (values: Values) => {
    const errors: any = {}

    if (!values.validation_forms || (values.validation_forms.length == 0)) errors.validation_forms = localization.required;
    if (!values.thesis_pdf) errors.thesis_pdf = localization.required;
    if (!values.paper_id_pdf) errors.paper_id_pdf = localization.required;
    if (!values.paper_en_pdf) errors.paper_en_pdf = localization.required;
    if (!values.resume_id_pdf) errors.resume_id_pdf = localization.required;
    if (!values.resume_en_pdf) errors.resume_en_pdf = localization.required;

    return errors;
  }

  return (
    <Form
      onSubmit={onSubmit}
      validate={onValidate}
      initialValues={props.values ? props.values : {}}
      render={({ handleSubmit, form, submitting, pristine, values }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3} className={classes.mainGrid}>
            <Grid item xs={4} sm={4}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.advisorsValidationForms}</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Field name="validation_forms">
                {props => (
                  <FileUploadField
                    accept=".pdf,.jpg,.png,.pdf"
                    title={localization.uploadAdvisorsValidationForms}
                    maxSize={5*1024*1024}
                    values={props.input.value}
                    fileKind="Halaman Pengesahan Dosen Pembimbing"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                    multiple
                  />
                )}
              </Field>
            </Grid>
            <Grid item xs={4} sm={4}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.thesisDraft} (.docx)</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Field name="thesis_docx">
                {props => (
                  <FileUploadField
                    accept=".docx"
                    title={localization.uploadThesis}
                    maxSize={maxUploadSize}
                    values={props.input.value}
                    fileKind="Thesis"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={4} sm={4}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.thesisDraft} (.pdf)</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Field name="thesis_pdf">
                {props => (
                  <FileUploadField
                    accept=".pdf"
                    title={localization.uploadThesis}
                    maxSize={maxUploadSize}
                    values={props.input.value}
                    fileKind="Thesis"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={4} sm={4}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.paper} - Bahasa Indonesia (.pdf)</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Field name="paper_id_pdf">
                {props => (
                  <FileUploadField
                    accept=".pdf"
                    title={localization.uploadPaper}
                    maxSize={10*1024*1024}
                    values={props.input.value}
                    fileKind="Makalah - Bahasa Indonesia"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={4} sm={4}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.paper} - English (.pdf)</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Field name="paper_en_pdf">
                {props => (
                  <FileUploadField
                    accept=".pdf"
                    title={localization.uploadPaper}
                    maxSize={10*1024*1024}
                    values={props.input.value}
                    fileKind="Makalah - English"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={4} sm={4}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.resume} - Bahasa Indonesia (.pdf)</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Field name="resume_id_pdf">
                {props => (
                  <FileUploadField
                    accept=".pdf"
                    title={localization.uploadResume}
                    maxSize={10*1024*1024}
                    values={props.input.value}
                    fileKind="Resume - Bahasa Indonesia"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={4} sm={4}>
              <Typography variant="body1" className={classes.gridLabel}>{localization.resume} - English (.pdf)</Typography>
            </Grid>
            <Grid item xs={8} sm={8}>
              <Field name="resume_en_pdf">
                {props => (
                  <FileUploadField
                    accept=".pdf"
                    title={localization.uploadResume}
                    maxSize={10*1024*1024}
                    values={props.input.value}
                    fileKind="Resume - English"
                    onChanged={(file) => {
                      props.input.onChange(file);
                    }}
                    error={(props.meta.error || props.meta.submitError) && props.meta.touched ? (props.meta.error || props.meta.submitError) : undefined}
                  />
                )}
              </Field>
            </Grid>

            <Grid item xs={6}>
              <Button
                variant="contained"
                color="primary"
                startIcon={<EditIcon />}
                type="submit"
                disabled={isSaving}
              >Submit</Button>
              {isSaving && <CircularProgress size={20} style={{marginLeft: 10}} />}
            </Grid>
            <Grid item xs={6} className={classes.alignRight}>
              <Button
                variant="contained"
                onClick={props.onCancelled}
              >Cancel</Button>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
}

export {ThesisPostDefenseForm};